import React from "react";
import { Link } from "gatsby";

const createPaginationNav = (slug, pageContext) => {
  if (pageContext.totalPages > 1) {
    const currentPage = pageContext.current || 1;
    const totalPages = pageContext.totalPages;
    const pages = [];

    // If 5 or fewer pages, show all
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Near the beginning: show 1, 2, 3, 4, 5, ...
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        if (totalPages > 5) {
          pages.push("ellipsis-end");
        }
      }
      // Near the end: show ..., (last-4), (last-3), (last-2), (last-1), last
      else if (currentPage >= totalPages - 2) {
        if (totalPages > 5) {
          pages.push("ellipsis-start");
        }
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      }
      // In the middle: show ..., (current-2), (current-1), current, (current+1), (current+2), ...
      else {
        pages.push("ellipsis-start");
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pages.push(i);
        }
        pages.push("ellipsis-end");
      }
    }

    return pages.map((page, index) => {
      if (page === "ellipsis-start" || page === "ellipsis-end") {
        return (
          <li key={`ellipsis_${index}`} className="ellipsis">
            <span>...</span>
          </li>
        );
      }

      const isActive = page === currentPage;
      const pageUrl = page === 1 ? slug : `${slug}page/${page}`;

      return (
        <li key={`link_${page}`}>
          <Link to={pageUrl} aria-current={isActive ? "page" : undefined}>
            {page}
          </Link>
        </li>
      );
    });
  }
};

export default createPaginationNav;
